import { Box } from "@mui/material";
import { ScoreBox } from "./ScoreBox/ScoreBox";
import { MainScore } from "src/api/client-api/olapScores/olapScoresSchema";
import { ScoreWithVariation } from "src/services/ScoreService";
import { ReferenceEntityData } from "./ScoreScatterPlot";

export type ScatterBoxProps = {
    title: string;
    score?: MainScore;
    prevScore?: MainScore;
    scoreWithVariation: ScoreWithVariation;
    isRefetching?: boolean;
    referenceScore: number | null;
    onScoreDistributionClick?: (scoreId: number) => void;
    prevCampaignName?: string;
    atLeastOnePostLocked?: boolean;
    referenceEntityData?: ReferenceEntityData;
};

export const ScatterBox = (props: ScatterBoxProps) => {
    const {
        title,
        score,
        prevScore,
        scoreWithVariation,
        referenceScore,
        onScoreDistributionClick,
        prevCampaignName = "",
        isRefetching = false,
        atLeastOnePostLocked = false,
        referenceEntityData,
    } = props;

    return (
        <Box sx={{ flex: 1 }}>
            <ScoreBox
                title={title}
                score={score}
                prevScore={prevScore}
                scoreWithVariation={scoreWithVariation}
                referenceScore={referenceScore}
                prevCampaignName={prevCampaignName}
                isRefetching={isRefetching}
                onScoreDistributionClick={onScoreDistributionClick}
                atLeastOnePostLocked={atLeastOnePostLocked}
                referenceEntityData={referenceEntityData}
            />
        </Box>
    );
};
